import * as React from 'react';
import { useRecordContext } from 'react-admin';

import { Typography } from '@material-ui/core';

function getDados(dados) {
  const unidades = dados.unidades ? `${dados.unidades} Un` : '-';
  return unidades;
}

const UnidadesField = ({ ...props }) => {
  const record = useRecordContext(props);

  const label = record ? (record.record ? getDados(record.record) : '-') : '-';

  return (
    <div>
      <Typography variant="subtitle1">{label}</Typography>
    </div>
  );
};

export default UnidadesField;
